import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackClickOfferGroupLink } from './tracking';
import { getLinkTextForAllOffers } from './utils/getLinkTextForAllOffers';
import { selectTracking } from '../../../slices';
import { OfferContainer } from '../OfferContainer';
import { OfferGroup } from 'shared/components/OfferGroup/OfferGroup';
import { IOfferGroup } from 'shared/types/offers';

type TProps = {
  offerGroup: IOfferGroup;
  position: number;
};

export const OfferGroupContainer: React.FC<TProps> = ({ offerGroup, position }) => {
  const tracking = useSelector(selectTracking);

  const { name, count, link } = offerGroup;

  const offers = offerGroup.offers
    ? offerGroup.offers.map((offer, position) => {
        return <OfferContainer offer={offer} position={position} key={`offer_${offer.id}`} />;
      })
    : null;

  const textLink = React.useMemo(() => {
    return getLinkTextForAllOffers(count || '');
  }, [count]);

  const handleClick = React.useCallback(() => {
    const category = offerGroup.offers ? offerGroup.offers[0].category : '';

    trackClickOfferGroupLink([category], tracking.page, tracking.products);
  }, [offerGroup.offers, tracking]);

  if (!offers) {
    return null;
  }

  return (
    <OfferGroup
      position={position}
      offerGroup={{ name: name ?? undefined, count: count ?? undefined, link: link ?? undefined }}
      onClick={handleClick}
      textLink={textLink}
      offers={offers}
    />
  );
};
